// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.perxis-auto-1_16_0-container {
  /* Max Width */
  --perxis-auto-container-max-width-inner: var(--perxis-auto-container-max-width, 1400px);
  /* End Max Width */
  /* Padding */
  --perxis-auto-container-padding-xxs-inner: var(--perxis-auto-container-padding-xxs, 18px);
  --perxis-auto-container-padding-xs-inner: var(--perxis-auto-container-padding-xs, 18px);
  --perxis-auto-container-padding-sm-inner: var(--perxis-auto-container-padding-sm, 28px);
  --perxis-auto-container-padding-md-inner: var(--perxis-auto-container-padding-md, 42px);
  --perxis-auto-container-padding-lg-inner: var(--perxis-auto-container-padding-lg, 60px);
  --perxis-auto-container-padding-xl-inner: var(--perxis-auto-container-padding-xl, 84px);
  --perxis-auto-container-padding-xxl-inner: var(--perxis-auto-container-padding-xxl, 112px);
  /* End Padding */
  position: relative;
  box-sizing: content-box;
  margin: 0 auto;
  max-width: var(--perxis-auto-container-max-width-inner);
}
@media (min-width: 1600px) {
  .perxis-auto-1_16_0-container {
    padding-left: var(--perxis-auto-container-padding-xxl-inner);
    padding-right: var(--perxis-auto-container-padding-xxl-inner);
  }
}
@media (min-width: 1200px) and (max-width: 1599px) {
  .perxis-auto-1_16_0-container {
    padding-left: var(--perxis-auto-container-padding-xl-inner);
    padding-right: var(--perxis-auto-container-padding-xl-inner);
  }
}
@media (min-width: 992px) and (max-width: 1199px) {
  .perxis-auto-1_16_0-container {
    padding-left: var(--perxis-auto-container-padding-lg-inner);
    padding-right: var(--perxis-auto-container-padding-lg-inner);
  }
}
@media (min-width: 768px) and (max-width: 991px) {
  .perxis-auto-1_16_0-container {
    padding-left: var(--perxis-auto-container-padding-md-inner);
    padding-right: var(--perxis-auto-container-padding-md-inner);
  }
}
@media (min-width: 576px) and (max-width: 767px) {
  .perxis-auto-1_16_0-container {
    padding-left: var(--perxis-auto-container-padding-sm-inner);
    padding-right: var(--perxis-auto-container-padding-sm-inner);
  }
}
@media (min-width: 480px) and (max-width: 575px) {
  .perxis-auto-1_16_0-container {
    padding-left: var(--perxis-auto-container-padding-xs-inner);
    padding-right: var(--perxis-auto-container-padding-xs-inner);
  }
}
@media (min-width: 0px) and (max-width: 479px) {
  .perxis-auto-1_16_0-container {
    padding-left: var(--perxis-auto-container-padding-xxs-inner);
    padding-right: var(--perxis-auto-container-padding-xxs-inner);
  }
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
